import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigationAction } from '@ngrx/router-store';
import { filter, map } from 'rxjs';

import { SegmentTrackEvent } from '@ninety/platform/models/analytics/segment/segment-track-event.enum';

import { SegmentActions } from '../analytics/segment/segment.actions';
import { BreakpointActions } from '../viewport/viewport.actions';
import { NinetyBreakpointNames } from '../viewport/viewport.model';

import { NavigationActions } from './navigation.actions';

@Injectable()
export class NavigationStateEffects {
  private actions$ = inject(Actions);

  trackABTestNavigation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NavigationActions.trackABTestNavigation),
      map(({ feature, label }) => {
        return SegmentActions.track({ event: SegmentTrackEvent.NAVIGATION_AB_TEST, params: { feature, label } });
      })
    )
  );

  closeHamburgerMenuOnScreenResize$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BreakpointActions.breakpointSet),
      filter(
        ({ currentScreenSize }) =>
          currentScreenSize === NinetyBreakpointNames.Large || currentScreenSize === NinetyBreakpointNames.XLarge
      ),
      map(() => NavigationActions.closeHamburgerMenu())
    )
  );

  closeHamburgerMenuOnNavigation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(routerNavigationAction),
      map(() => NavigationActions.closeHamburgerMenu())
    )
  );
}
